import React, { useState } from "react";
import classes from "./passwordInput.module.scss";

const EyeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M1.54688 9.26054C1.48437 9.09215 1.48437 8.90692 1.54688 8.73854C2.15565 7.26243 3.18902 6.00032 4.51596 5.11221C5.8429 4.22411 7.40366 3.75 9.00038 3.75C10.5971 3.75 12.1579 4.22411 13.4848 5.11221C14.8117 6.00032 15.8451 7.26243 16.4539 8.73854C16.5164 8.90692 16.5164 9.09215 16.4539 9.26054C15.8451 10.7366 14.8117 11.9988 13.4848 12.8869C12.1579 13.775 10.5971 14.2491 9.00038 14.2491C7.40366 14.2491 5.8429 13.775 4.51596 12.8869C3.18902 11.9988 2.15565 10.7366 1.54688 9.26054Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const EyeSlashIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M2.25 2.25L15.75 15.75"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.23047 7.27148C6.76484 7.74961 6.49609 8.38711 6.49609 9.07148C6.49609 10.4515 7.61953 11.5749 8.99953 11.5749C9.68391 11.5749 10.3214 11.3062 10.7996 10.8405"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0723 13.1484C11.8723 13.9219 10.4648 14.3437 8.99984 14.3437C7.40234 14.3437 5.84109 13.8672 4.51484 12.9766C3.18859 12.0859 2.15547 10.8203 1.54609 9.34219C1.48359 9.17344 1.48359 8.98594 1.54609 8.81719C1.85234 8.07656 2.26484 7.39219 2.77109 6.78281"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.2285 11.2172C15.7348 10.6078 16.1473 9.92344 16.4535 9.18281C16.516 9.01406 16.516 8.82656 16.4535 8.65781C15.8441 7.17969 14.811 5.91406 13.4848 5.02344C12.1585 4.13281 10.5973 3.65625 9.00038 3.65625C8.52381 3.65625 8.05038 3.70312 7.58569 3.79688"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PasswordInput = ({
  name,
  id,
  placeholder,
  value,
  onChange,
  onBlur,
  label,
  preventCopyPaste,
  className,
  wrapperClassName,
  inputClassName,
  labelClassName,
  floatingLabel,
  autoComplete,
  error,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const blockEvent = (e) => {
    e.preventDefault();
    return false;
  };

  return (
    <div className={className || "uk-margin"}>
      {!floatingLabel && label && (
        <label className={labelClassName || "uk-form-label text-muted uk-text-bold"} htmlFor={id}>
          {label}
        </label>
      )}
      <div className={`${wrapperClassName || "uk-form-controls"} ${classes.input_wrap}`}>
        <input
          type={showPassword ? "text" : "password"}
          className={inputClassName || "uk-input"}
          name={name}
          id={id}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          autoComplete={autoComplete}
          onPaste={preventCopyPaste ? blockEvent : undefined}
          onCopy={preventCopyPaste ? blockEvent : undefined}
        />
        {floatingLabel && label && (
          <label className={labelClassName} htmlFor={id}>
            {label}
          </label>
        )}
        <button
          type="button"
          className={classes.eye_toggle}
          onClick={() => setShowPassword((prev) => !prev)}
          aria-label={showPassword ? "Hide password" : "Show password"}
        >
          {showPassword ? <EyeSlashIcon /> : <EyeIcon />}
        </button>
      </div>
      {error}
    </div>
  );
};

export default PasswordInput;
